<div>
  <div class="mt-3 ml-1" *ngIf="layoutMenu === 4">
    <div
      (mouseenter)="this.dropdown = false"
      (mouseleave)="this.dropdown = false"
      (click)="this.dropdown = false"
    >
      <button
        class="clear-btn"
        (click)="onFilterClear.emit()"
        [style.backgroundColor]="SITE.backgroundColorSliderSuperior"
        i18n
      >
        Todos os departamentos
      </button>
      <div
        *ngIf="menuDinamico"
        class="{{ this.dropdown ? '' : 'hide' }} dropdown-treeview"
      >
        <app-catalog-dynamic-dropdown
          (sendFilters)="filtrarPorMenuDinamico.emit($event)"
          [filtersIn]="filtros"
          (breadCrumb)="getBreadCrumb($event)"
        ></app-catalog-dynamic-dropdown>
      </div>
    </div>
    <!-- <h4
      *ngIf="productService.filtroDescr.length > 0 || this.selected.length > 0"
      class="filters-selected-title"
    >
      Filtros selecionados
    </h4>
    <div *ngFor="let sel of this.selected">
      <div class="selected-filter-container">
        <h6>{{ sel.parent }}</h6>
        <div class="column">
          <span
            *ngFor="let s of sel.items"
            class="badge-primary selected-item row mb-1"
          >
            <span class="selected-text">{{ s.name }}</span>
            <span
              class="badge mr-1 filter-close-button close-selected"
              [style.backgroundColor]="'#fff'"
              style="cursor: pointer"
              (click)="removeItem([sel, s.id])"
              >X</span
            >
          </span>
        </div>
      </div>
    </div> -->
    <!-- <div
      *ngIf="productService.filtro['busca']"
      style="border-bottom: 1px solid black"
      class="mb-3 pb-1"
    >
      <span *ngFor="let search of productService.filtro['busca']">
        <span
          class="badge badge-secondary mr-1 filter-close-button"
          style="cursor: pointer"
          (click)="onClearSearch.emit(search)"
          >X</span
        >
        <span class="filtroDescrBusca">{{ search }}</span>
      </span>
    </div> -->

    <div>
      <!-- <div *ngFor="let filter of productService.filtroDescr">
        <span class="badge badge-primary">
          <span class="descr1">{{ filter.label }}</span>
          <span
            class="badge badge-light"
            (click)="
              onClearSearchDescription.emit({
                id: filter.id,
                filter: filter.filtro
              })
            "
            >X</span
          >
        </span>
      </div> -->
      <!-- <div
        *ngFor="let filter of productService.filtroDescr"
        class="selected-filter-container"
      >
        <h6 (click)="send(productService)">{{ filter.nome }}</h6>
        <span class="badge badge-primary">
          <span class="descr1">{{ filter.label }}</span>
          <span
            class="badge badge-light"
            (click)="
              onClearSearchDescription.emit({
                id: filter.id,
                filter: filter.filtro
              })
            "
            >X</span
          >
        </span>
      </div> -->
    </div>
    <!-- <button
      class="clear-button"
      (click)="onFilterClear.emit()"
      *ngIf="productService.filtroDescr.length > 0 || this.selected.length > 0"
    >
      Limpar Filtros
    </button> -->
  </div>
  <div
    *ngIf="productService.filtro['busca']"
    style="border-bottom: 1px solid black"
    class="mb-3 pb-1"
  >
    <span *ngFor="let search of productService.filtro['busca']">
      <span
        class="badge badge-secondary mr-1 filter-close-button"
        style="cursor: pointer"
        (click)="onClearSearch.emit(search)"
        >X</span
      >
      <span class="filtroDescrBusca">{{ search }}</span>
    </span>
  </div>
  <div class="mt-3 ml-1" *ngIf="layoutMenu === 4">
    <app-catalog-dynamic-menu-click
      (sendFilters)="filtrarPorMenuDinamico.emit($event)"
      [filtersIn]="filtros"
      (breadCrumb)="getBreadCrumb($event)"
    ></app-catalog-dynamic-menu-click>
  </div>

  <!-- <div class="mt-3 ml-1">
    <app-catalog-dynamic-menu
      (sendFilters)="filtrarPorMenuDinamico.emit($event)"
      *ngIf="menuDinamico"
    ></app-catalog-dynamic-menu>
  </div> -->

  <div class="mt-3 ml-1">
    <!-- <h4 class="filters-title" *ngIf="catalogItems.length > 0">Filtros</h4> -->
    <div *ngFor="let cat of catalogItems" class="filtro-linha">
      <div
        *ngIf="filters[cat.id] && (filters[cat.id].length || term !== '')"
        class="menu-filtro"
      >
        <a
          data-toggle="collapse"
          href="#box{{ cat.id }}"
          class="panel-heading {{ filtroColapsado ? 'collapsed': ''}}"
          style="font-weight: 900 !important; font-size: 1.2rem"
        >
          <span
            class="filtrarpor"
            style="font-weight: 900 !important; font-size: 1.2rem"
            i18n
            >Filtro por </span
          >{{ cat.descr }}</a
        >
        <div
          id="box{{ cat.id }}"
          class="list-group list-group-flush panel-collapse collapse {{ filtroColapsado ? '': 'show'}}"
        >
        <input type="text" class="form-control search-filtro" [placeholder]='"Buscar " + cat.descr' (input)="onSearch($event.target.value ,cat.id)"/>
          <label
            *ngFor="let filter of filters[cat.id]; let i = index"
            class="list-group-item list-group-item-action"
            [style]="'font-size:12px'"
          >
            <input
              [disabled]="productService.loadingCatalogo"
              type="checkbox"
              [checked]="
                productService.filtro[cat.id] &&
                productService.filtro[cat.id].indexOf(filter.id) > -1
              "
              (click)="
                onFilter.emit({
                  filtro: cat.id,
                  filtroDescr: filter.nome,
                  id: filter.id,
                  nome: cat.descr,
                  event: $event
                })
              "
            />
            {{ filter.nome }}
            <span
              *ngIf="SITE.mostraSomaCaracteristicaCatalogo"
              class="badge badge-secondary"
              >{{ filter.count }}</span
            >
          </label>
        </div>
      </div>
    </div>
    <div class="mt-1 list-group list-group-flush">
      <!-- <label for="customRange2" class="range-label">Preço</label> -->
      <!-- <ngx-slider
        [(value)]="minValue"
        [(highValue)]="maxValue"
        [options]="options"
        (userChangeEnd)="onPriceFilter.emit($event)"
      ></ngx-slider> -->
    </div>
  </div>
</div>
